import React from 'react';
import { Clock3Icon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="bg-[#0A0A0A] px-5 py-16" data-id="element-236">
      <div className="mx-auto max-w-2xl border-2 border-red-500 bg-[#16161F] p-8 text-center sm:p-11" data-id="element-237">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.2em] text-red-400" data-id="element-238">
          <Clock3Icon className="h-4 w-4" data-id="element-239" /> Limited-time offer
        </p>
        <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-240">
          Launch price ends in:
        </h2>
        <div className="my-9" data-id="element-241">
          <CountdownTimer size="large" dark data-id="element-242" />
        </div>
        <p className="font-semibold text-white" data-id="element-243">
          After that, the price goes up and bonuses are removed.
        </p>
        <div className="mx-auto mt-7 max-w-sm" data-id="element-244">
          <div className="h-3 overflow-hidden border border-red-500/50 bg-[#0A0A0A]" data-id="element-245">
            <div className="h-full w-[72%] bg-red-500" data-id="element-246" />
          </div>
          <div className="mt-3 flex justify-between text-[10px] font-bold uppercase tracking-widest" data-id="element-247">
            <span className="text-red-400" data-id="element-248">Limited spots</span>
            <span className="text-[#B0B0C0]" data-id="element-249">72% claimed</span>
          </div>
        </div>
      </div>
    </section>;
}